import { render, staticRenderFns } from "./ThumbnailsParameter.vue?vue&type=template&id=e1852a12&scoped=true&"
import script from "./ThumbnailsParameter.vue?vue&type=script&lang=ts&"
export * from "./ThumbnailsParameter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1852a12",
  null
  
)

export default component.exports